export enum ENDPOINT_HTTP_METHOD {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete'
}
export enum VIEW_HTTP_METHOD {
  GET = 'get',
  POST = 'post'
}
export enum HTTP_STATUS_CODES {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  ACCEPTED = 202,
  CREATED = 201,
  SUCCESS = 200,
  ERROR = 500,
  POLICY_ACTIVATION_FAILED = 513,
  NOTFOUND = 404
}
export enum SUPPORTED_LOCALES {
  ENGLISH = 'en',
  FRENCH = 'fr'
}

export enum API_VERSION {
  DEFAULT = '1',
  FUTURE = '2'
}

export type ApiVersion = `${API_VERSION}`;

export enum Language {
  EN = 'EN',
  FR = 'FR'
}

export enum TOGGLE_LABELS {
  ENGLISH = 'EN',
  FRENCH = 'FR'
}

export enum TOGGLE_ARIA_LABELS {
  ENGLISH = 'English',
  FRENCH = 'Français'
}

export enum SELECT_TRANSLATION {
  ENGLISH = 'Select',
  FRENCH = 'Sélectionnez'
}
export const LOCALE_MAPPING = {
  en: 'en-ca',
  fr: 'fr-ca'
};

export const TRAVELLER_TYPE = {
  FAMILY: 'FAMILY',
  SINGLE: 'SINGLE',
  COMPANION: 'COMPANION',
  GROUP: 'GROUP',
  STAFF: 'STAFF',
  STUDENT: 'STUDENT'
};

export const TRANSLATION_SPACE = {
  DEFAULT: 'tripx-b2b',
  CM: 'coverme'
};

export const TRIP_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE'
};

export const ONE_SECOND_IN_MS = 1000;
export const SECS_IN_MIN = 60;
export const COOKIE_EXPIRY_OFFSET = 120;

export enum ProfileStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum EnglishTzCodes {
  ADT = 'ADT',
  CDT = 'CDT',
  EDT = 'EDT',
  PDT = 'PDT',
  MDT = 'MDT',
  NDT = 'NDT',
  AST = 'AST',
  CST = 'CST',
  EST = 'EST',
  PST = 'PST',
  MST = 'MST',
  NST = 'NST',
}

export enum FrenchTzCodes {
  HAA = 'HAA',
  HAC = 'HAC',
  HAE = 'HAE',
  HAP = 'HAP',
  HAR = 'HAR',
  HAT = 'HAT',
  HNA = 'HNA',
  HNC = 'HNC',
  HNE = 'HNE',
  HNP = 'HNP',
  HNR = 'HNR',
  HNT = 'HNT'
}

export enum LicenseType {
  AGENT = 'AGENT',
  AGENCY = 'AGENCY'
}

export enum EmployeeType {
  LIA = 'LIA',
  REGULAR = 'REGULAR',
  INDCONTRACTOR = 'INDCONTRACTOR',
  NA = 'NOT_APPLICABLE'
}

export enum LicenseStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  RENEWAL_PENDING = 'RENEWAL_PENDING',
  AUTHORIZED = 'AUTHORIZED',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED'
}

export const LicenseStatusLabels: Record<LicenseStatus, string> = {
  [LicenseStatus.AUTHORIZED]: 'Authorized',
  [LicenseStatus.IN_PROGRESS]: 'In Progress',
  [LicenseStatus.RENEWAL_PENDING]: 'Renewal Pending',
  [LicenseStatus.NOT_AUTHORIZED]: 'Not Authorized'
};

export enum ContactType {
  LICENSING = 'LICENSING',
  GENERAL_INQUIRY = 'GENERAL_INQUIRY',
  OPERATIONS = 'OPERATIONS',
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
  ACCOUNTING = 'ACCOUNTING'
}

export const ContactTypeLabels: Record<ContactType, string> = {
  [ContactType.LICENSING]: 'Licensing',
  [ContactType.GENERAL_INQUIRY]: 'General Inquiry',
  [ContactType.OPERATIONS]: 'Operations',
  [ContactType.MANAGER]: 'Manager',
  [ContactType.OWNER]: 'Owner',
  [ContactType.ACCOUNTING]: 'Accounting'
};

export enum PaymentGatewayType {
  MONERIS = 'MONERIS',
  ORGANIZATION = 'ORGANIZATION'
}

export enum AgentLicensedProvinces {
  SK = 'SK',
  NS = 'NS',
  NB = 'NB',
  PE = 'PE',
  YT = 'YT',
  NT = 'NT',
  NU = 'NU'
}

export enum AgencyLicensedProvinces {
  SK = 'SK',
  NS = 'NS',
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NL = 'NL',
  ON = 'ON',
  QC = 'QC',
  NB = 'NB'
}

export const provincesMap = {
  'Alberta': 'AB',
  'British Columbia': 'BC',
  'Manitoba': 'MB',
  'New Brunswick': 'NB',
  'Newfoundland and Labrador': 'NL',
  'Northwest Territories': 'NT',
  'Nova Scotia': 'NS',
  'Nunavut': 'NU',
  'Ontario': 'ON',
  'Prince Edward Island': 'PE',
  'Quebec': 'QC',
  'Saskatchewan':'SK',
  'Yukon': 'YT'
}

export const DS_SOURCE = {
  FRAME: 'frame',
  PARENT: 'parent'
};

export const DS_MESSAGE_TYPES = {
  SYSTEM: 'system',
  FIELD: 'field',
  PAGE: 'page',
  USER: 'user',
  IFRAME: 'iframe'
};

export const DS_FIELD_EVENTS = {
  ON_BLUR: 'onblur',
  ON_KEY_UP: 'onkeyup',
  ON_LOST_FOCUS: 'onlostfocus',
  ON_FOCUS: 'onfocus',
  ON_VALID: 'onvalid',
  ON_INVALID: 'oninvalid'
};

export const DS_SYSTEM_EVENTS = {
  ON_ERROR: 'onerror'
};

export const DS_IFRAME_EVENTS = {
  ON_READY: 'onready'
};

export const cardNumberStyle = {
  iframeBorder: '1px solid #c2c3c9',
  iframeScrolling: 'no',
  iframeWidth: '100%',
  iframeHeight: '42px',
  iframeDisplay: 'block'
};

export const iframeInputStylesInitial = `
  box-sizing: border-box;
  width: 100%;
  height: 46px;
  font-family:Manulife JH Sans,Helvetica,Arial,sans-serif;
  font-size: 16px;
  font-weight: 300;
  border: 1px solid #c2c3c9;
  border-style: solid;
`;

export const additionalStyles = {'background-size': '122px, 136px'};

//${brandingColors.red_error}
export const iframeInputStylesInvalid = `
  border: 2px solid #db1f00 !important;
`;
